import * as React from 'react';

const SVGSaved: React.SFC<SvgProps> = props => (
  <svg width={17} height={12} {...props}>
    <path
      fill="#63BA68"
      fillRule="nonzero"
      d="M16.039.152l.809.887-10.81 10.773-5.886-5.37.81-.886 5.077 4.632z"
    />
  </svg>
);

export default SVGSaved;
